const routes = [
    {
        path: '/contabilidade/tipos_documentos',
        component: () => import('../views/Listar'),
    },
    {
        path: '/contabilidade/tipos_documentos/adicionar',
        component: () => import('../views/Adicionar'),
    },
    {
        path: '/contabilidade/tipos_documentos/editar/:id',
        component: () => import('../views/Editar'),
    },
    {
        path: '/contabilidade/tipos_documentos/visualizar/:id',
        component: () => import('../views/Visualizar'),
    },
]

export default routes
